import Icon from 'veui/components/Icon'

Icon.register({
  'flow-loop': {
    paths: [
      {
        d: 'M641.17 601.92a32 32 0 01-8.27 31A351.9 351.9 0 0132 384a32 32 0 0164 0 288.14 288.14 0 00445.46 241.26L471.86 607a32 32 0 0116.28-61.9l130.28 34.28a32 32 0 0122.75 22.54zm69.05-350.36A351.91 351.91 0 00135.1 135.1a32 32 0 0014.48 53.57L279.86 223a32 32 0 1016.28-61.9l-69.6-18.31A288.08 288.08 0 01672 384a32 32 0 0064 0 350.68 350.68 0 00-25.78-132.44z'
      }
    ],
    width: '768',
    height: '768'
  }
})
